
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M.804 15.936a.921.921 0 01.018-.777.961.961 0 01.869-.551.916.916 0 01.411.1 9.852 9.852 0 004.118.908 9.672 9.672 0 003.729-.738 9.683 9.683 0 005.273-5.27 9.687 9.687 0 000-7.457.965.965 0 01.221-1.061.957.957 0 01.662-.264.964.964 0 01.411.09 11.641 11.641 0 015.883 6.156 11.684 11.684 0 01-6.363 15.23 11.6 11.6 0 01-4.434.879A11.622 11.622 0 01.804 15.936zm10.8 5.313a9.765 9.765 0 009.759-9.75 9.758 9.758 0 00-3.646-7.6 11.437 11.437 0 01.165 1.955 11.7 11.7 0 01-11.68 11.684 11.691 11.691 0 01-2.457-.264 9.755 9.755 0 007.856 3.971z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      